import { render, staticRenderFns } from "./students.vue?vue&type=template&id=36e04b4f&scoped=true"
import script from "./students.vue?vue&type=script&lang=js"
export * from "./students.vue?vue&type=script&lang=js"
import style0 from "./students.vue?vue&type=style&index=0&id=36e04b4f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e04b4f",
  null
  
)

export default component.exports